import { render, staticRenderFns } from "./CountryBlocks.vue?vue&type=template&id=188b5588&scoped=true&"
import script from "./CountryBlocks.vue?vue&type=script&lang=js&"
export * from "./CountryBlocks.vue?vue&type=script&lang=js&"
import style0 from "./CountryBlocks.vue?vue&type=style&index=0&id=188b5588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b5588",
  null
  
)

export default component.exports